import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import Page from '../../components/Page';
import PageHeader from '../../components/PageHeader';
import LotteryTab from '../../components/LotteryTab'
import Spacer from '../../components/Spacer';  
// import useBasisCash from '../../hooks/useBasisCash';

import moment from 'moment'
import Notice from '../../components/Notice';

import InfiniteScroll from 'react-infinite-scroller';
import _, { filter } from 'lodash'
import { Cron } from "croner";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import chip from './game_chip.png'
import { reaction } from 'mobx';
import stores from '../../state';
import { Empty, Spin, Button, message, Tag, Modal } from 'antd';
// import { Article } from '../Home/components/Article'
import Articles, { Context } from '../../contexts/Articles';
import DocumentTitle from 'react-document-title'
// import { useConfig } from '../../hooks/useConfig';;
import Parse from 'parse'
// import useMessage from '../../hooks/useMessage';
import ZsxqEmpty from '../../components/ZsxqEmpty'
import { useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
import sleep from 'sleep-promise';
import bg from './bg.png'
import time_bg from './time_bg.svg'
import lottery_type_bg from './lottery_type_bg.svg'
import useDrawResult, { hit, useCurrentGame, useHistoryDrawResult } from '../../hooks/useDraw';
import { TabProps } from '../../components/LotteryTab';
import { useCountdown } from '../../hooks/useCountdown';
import { getCurrentIssueNumber, secondToMinuteStr ,getNextIssueNumber } from '../../utils/util';
import DrawHistoryModal from '../../components/DrawHistoryModal';
import LotterySegmentTab from '../../components/LotterySegmentTab';
import BottomTab from '../../components/BottomTab';
import HitTrend from '../../components/HitTrend';
import LanguageButton from '../../components/LanguageButton';
import { useTranslation } from 'react-i18next';
import { CountDown, DrawPanelBackground } from '../../components/LotteryTab/LotteryTab';
import LotteryDrawAnim from './LotteryDrawAnim';
import ReactLoading from 'react-loading'
import { ClipLoader } from 'react-spinners';
import LotteryDrawHistory from './LotteryDrawHistory';
import LotteryPlan from './LotteryPlan';
import { useNews } from '../../hooks/useNews';
import { useDomainConfig } from '../../hooks/useDomainConfig';
import theme from '../../theme';
// import n0 from './img/0.png'
import wingo_circle_30s from './wingoimg/wingo_circle_30s.svg'
import wingo_circle_1m from './wingoimg/wingo_circle_1m.svg'
import wingo_circle_3m from './wingoimg/wingo_circle_3m.svg'
import wingo_circle_5m from './wingoimg/wingo_circle_5m.svg'

import _5d_circle_1m from './5dimg/5d_circle_1m.svg'
import _5d_circle_3m from './5dimg/5d_circle_3m.svg'
import _5d_circle_5m from './5dimg/5d_circle_5m.svg'
import _5d_circle_10m from './5dimg/5d_circle_10m.svg'
// 
import wingo_round_30s from './img/wingo_round_30s.svg'
import wingo_round_1m from './img/wingo_round_1m.svg'
import wingo_round_3m from './img/wingo_round_3m.svg'
import wingo_round_5m from './img/wingo_round_5m.svg'

import _5d_round_1m from './img/5d_round_1m.svg'
import _5d_round_3m from './img/5d_round_3m.svg'
import _5d_round_5m from './img/5d_round_5m.svg'
import _5d_round_10m from './img/5d_round_10m.svg'

import k3_round_1m from './img/k3_round_1m.svg'
import k3_round_3m from './img/k3_round_3m.svg'
import k3_round_5m from './img/k3_round_5m.svg'
import k3_round_10m from './img/k3_round_10m.svg'

import k3_circle_1m from './k3img/k3_circle_1m.svg' 
import k3_circle_3m from './k3img/k3_circle_3m.svg' 
import k3_circle_5m from './k3img/k3_circle_5m.svg' 
import k3_circle_10m from './k3img/k3_circle_10m.svg' 

import trxwingo_round_1m from './img/trxwingo_round_1m.svg'
import trxwingo_round_3m from './img/trxwingo_round_3m.svg'
import trxwingo_round_5m from './img/trxwingo_round_5m.svg' 
 
import trxwingo_circle_1m from './wingoimg/trxwingo_circle_1m.svg'
import trxwingo_circle_3m from './wingoimg/trxwingo_circle_3m.svg'
import trxwingo_circle_5m from './wingoimg/trxwingo_circle_5m.svg'


import draw_result_bg from './img/draw_result_bg.svg'

const roundButtons = [
    [{lotteryType:'wingo_30s',title:'Win Go 30s',type:30,icon:wingo_round_30s,cirleIcon:wingo_circle_30s},
    {lotteryType:'wingo_1m',title:'Win Go 1min',type:1,icon:wingo_round_1m,cirleIcon:wingo_circle_1m},
    {lotteryType:'wingo_3m',title:'Win Go 3min',type:2,icon:wingo_round_3m,cirleIcon:wingo_circle_3m},
    {lotteryType:'wingo_5m',title:'Win Go 5min',type:3,icon:wingo_round_5m,cirleIcon:wingo_circle_5m},],
  
    [ {lotteryType:'k3_1m',title:'K3 1min',type:9,icon:k3_round_1m,cirleIcon:k3_circle_1m},
      {lotteryType:'k3_3m',title:'K3 3min',type:10,icon:k3_round_3m,cirleIcon:k3_circle_3m},
      {lotteryType:'k3_5m',title:'K3 5min',type:11,icon:k3_round_5m,cirleIcon:k3_circle_5m},
      {lotteryType:'k3_10m',title:'K3 10min',type:12,icon:k3_round_10m,cirleIcon:k3_circle_10m},],

   [ {lotteryType:'5d_1m',title:'5D 1min',type:5,icon:_5d_round_1m,cirleIcon:_5d_circle_1m},
    {lotteryType:'5d_3m',title:'5D 3min',type:6,icon:_5d_round_3m,cirleIcon:_5d_circle_3m},
    {lotteryType:'5d_5m',title:'5D 5min',type:7,icon:_5d_round_5m,cirleIcon:_5d_circle_5m},
    {lotteryType:'5d_10m',title:'5D 10min',type:8,icon:_5d_round_10m,cirleIcon:_5d_circle_10m},],

 

    [ {lotteryType:'trxwingo_1m',title:'TrxWinGo 1min',type:13,icon:trxwingo_round_1m,cirleIcon:trxwingo_circle_1m},
      {lotteryType:'trxwingo_3m',title:'TrxWinGo 3min',type:14,icon:trxwingo_round_3m,cirleIcon:trxwingo_circle_3m},
      {lotteryType:'trxwingo_5m',title:'TrxWinGo 5min',type:15,icon:trxwingo_round_5m,cirleIcon:trxwingo_circle_5m},
      null ]
]

const useGameTabs = (game:string)=>{ 
  const tabs:TabProps[] = useMemo(()=>{
    switch(game){
      case 'wingo':
        return [{
              title:'Win',
              path:'WinGo_30_latest',
              minute:'30s',
              type:30, 
            },{
              title:'Win',
              path:'WinGo_1_latest',
              minute:'1Min',
              type:1,
            },{
              title:'Win',
              path:'WinGo_2_latest',
              minute:'3Min',
              type:2,
            },{
              title:'Win',
              path:'WinGo_3_latest',
              minute:'5Min',
              type:3, 
            }
            ]
      case '5d':
        return [{
          title:'5D ',
          path:'5D_5_latest',
          minute:'1Min',
          type:5,
        },{
          title:'5D ',
          path:'5D_6_latest',
          minute:'3Min',
          type:6,
        },{
          title:'5D ',
          path:'5D_7_latest',
          minute:'5Min',
          type:7,
        },{
          title:'5D ',
          path:'5D_8_latest',
          minute:'10Min',
          type:8, 
      }]
      
      case 'k3':
        return [{
          title:'K3 ',
          path:'K3_9_latest',
          minute:'1Min',
          type:9,
        },{
          title:'K3 ',
          path:'K3_10_latest',
          minute:'3Min',
          type:10,
        },{
          title:'K3 ',
          path:'K3_11_latest',
          minute:'5Min',
          type:11,
        },{
          title:'K3 ',
          path:'K3_12_latest',
          minute:'10Min',
          type:12, 
      }]
      case 'trxwingo':
        return  [{
          title:'Trx ',
          path:'TrxWinGo_13_latest',
          minute:'1Min',
          type:13,
        },{
          title:'Trx ',
          path:'TrxWinGo_14_latest',
          minute:'3Min',
          type:14,
        },{
          title:'Trx ',
          path:'TrxWinGo_15_latest',
          minute:'5Min',
          type:15,
        },{
          title:'Trx ',
          path:'TrxWinGo_16_latest',
          minute:'10Min',
          type:16, 
      }]
    }
    return 
  },[game])
  return tabs
}
const Home: React.FC = () => {
  //  let [displayedArticles,setDisplayedArticles] = useState([])
  // 用数组不太好，用对象比较好
//    const {articles,setArticles} = useArticles({})
    // console.log('home content',new Date())
    const {articles,setArticles} = useContext(Context)
    const [farestArticle,setFarestArticle] = useState<Parse.Object>()
    //  const farestArticle:Parse.Object = useMemo(()=>_.last(articles),[articles])
    const [displayedImages,setDisplayedImages] = useState([])
    //  const hasMore = useMemo(()=>(articles||[]).length > 0,[articles])
    const [hasMore,setHasMore] = useState(true)
    const [loading,setLoading] = useState(false)
    // useConfig()
    const game = useCurrentGame()
    const [drawData,setDrawData] = useState<{[key:string]:[value:any]}>({})
    const location = useLocation()
    const paths:string[] = useMemo(()=>{
      // 16种开奖
      const lotterys = ['WinGo'];
      let _paths=[]
      for(let j = 0;j<lotterys.length;j++){
        for(let i = 1;i<5;i++){
          const typeId=4*j+i; 
            try{
              // paths.push(lotterys[j]+'_'+typeId+'_latest')
              // @ts-ignore
              _paths.push(lotterys[j]+'_'+typeId+'_latest')
              // console.log(typeId,lotterys[j],new Date(),) 
            }catch(e){
              console.error('e',e)
            }
        }
      }
      return _paths
    },[drawData])
    const [countdownData,setCountDownData] = useState<{[key:string]:[value:any]}>({})
  
    useEffect(()=>{
      // updateDrawResult()
    },[])
        
  const history = useHistory() 
  
  const tabs:TabProps[] = useGameTabs(game)

  const tab = useMemo(()=>{
      const item = roundButtons.flatMap(i=>i).filter(i=>{
        const match = i?.lotteryType == location.pathname.replace('/','')
        console.log('match',i?.lotteryType,location.pathname.replace('/',''),match)
        return match
    })
    // console.log('item',item[0])
      return item[0]
  },[location])

  // getCurrentIssueNumber(0,new Date())
  const [selectedTab,setSelectedTab] = useState<TabProps>(
    // tabs?.[0]
    tabs?.filter(t=>t.type==tab.type)?.[0]
  )
  console.log('selectedTab',tabs,tab,selectedTab)

  useEffect(()=>{
    if(tab){
      setSelectedTab(tabs?.filter(t=>t.type==tab.type)?.[0])
    }
    console.log('tab',tabs,tab,selectedTab)
  },[tab,tabs])
  // useEffect(()=>{
  //   setSelectedTab(tabs?.[0])
  // },[tabs])
  
  // const {drawResult,loadingStatus,refreshDrawResult} = useDrawResult(selectedTab)
  const {historyDrawResult,loadingStatus:loadingHistoryStatus,loadMore,hitRate,hitTrend} = useHistoryDrawResult(selectedTab)
  // useEffect(()=>{
  //   // 触发开奖历史更新
  //     loadMore(true) 
  // },[drawResult]) 
  const refreshDrawHistory = useCallback(()=>{
    loadMore(true)
  },[selectedTab])
  const {t} = useTranslation()
  const [selectedList,setSelectedList] = useState(0)
  const listTab = useMemo(()=>{
    return [t('Draws'),t('Plans'),t('News'),]
    // return [t('Plans'),t('Draws')]
  },[])
  const domainConfig = useDomainConfig()
  console.log('location.pathname',location.pathname)

  const news = useNews(null,domainConfig?.get('authorName'))
  // @ts-ignore
  const [countdown] = useCountdown(selectedTab?.type,historyDrawResult?.[0]?.issueNumber || 0,refreshDrawHistory)
  const [open,setOpen] = useState(false)
  const currentDrawResult = useMemo(()=>{
      switch(game){
        case 'wingo':
          if(historyDrawResult.length>0){
            const drawResult = historyDrawResult?.[1]
            // @ts-ignore
            const premium = _.slice(historyDrawResult,1,6).map(draw=>draw?.content?.number).join('')
            // @ts-ignore
            drawResult.content.premium = premium
            return drawResult
          }
          return null
        default:
          return historyDrawResult?.[1]
      }
  },[historyDrawResult,game])
  const [openLotteryTypeModal,setOpenLotteryTypeModal] = useState(false)
  return (
    <Page showTopBar={false}>
       {/* {articles?articles?.length:'empty'} */}
      <DocumentTitle title='wingoanalyst'/>
        {/* 16个彩种 */}
        {/* <Spacer size='md'/> */}
        {/* {paths.map(draw=>{
           
        })} */}
        
        <StyledHomeTopBackgroundWrapper>
        
            <LotterySegmentTab />  
           
            {/* <LotteryTab onTabChanged={(tab)=>{
              // console.log('onTabChanged',tab)
                setSelectedTab(tab)
            }} tabs={tabs} activeTab={selectedTab}/> */}
            <div style={{width:'100%',padding:10,position:'relative',overflow:'hidden'}}>
              
              <div style={{display:'flex',flexDirection:'row'}}>
                <div style={{display:'flex',flexDirection:'column',flex:261,position:'relative' }} id='lottery_type_div'  onClick={()=>setOpenLotteryTypeModal(true)}>
                      <div style={{width:'100%',paddingTop:9}}>
                        <img src={lottery_type_bg}  style={{aspectRatio:293/148, width:'100%',height:'100%'}} />
                      </div>
                      <div style={{position:'absolute',left:0,right:0,top:0,bottom:0}}>
                        <div style={{width:'38.2%',borderRadius:1000,}}>
                          <img src={tab?.cirleIcon} style={{width:'100%',aspectRatio:2}}/>
                        </div>
                      </div>
                      <div style={{position:'absolute',left:0,right:0,top:0,bottom:0,display:'flex',flexDirection:'row-reverse',justifyContent:'space-between',paddingRight:15,paddingTop:10,alignItems:'center'}}>
                       
                        <div style={{maxWidth:'50%',textAlign:'center',fontSize:12,display:'flex',flexDirection:'column',flex:1,justifyContent:'space-around',height:'100%',alignItems:'center'}}>
                          {/* {JSON.stringify(tab)} */}
                          {/* @ts-ignore */}
                          <div style={{fontWeight:'bold',lineHeight:1.3}}>{tab?.title}</div>
                            <div style={{color:'#3478FE',background:'#E8F0FF',borderRadius:100,lineHeight:1.5,paddingLeft:10,paddingRight:10}}>
                              more
                            </div>
                          </div>
                      </div>
                </div>
                <div style={{width:5}}/>
                <div style={{flex:430, display:'flex',position:'relative'}}>
                      <div style={{width:'100%',paddingTop:9}}>
                        <img src={time_bg}  style={{aspectRatio:430/116, width:'100%',height:'100%'}} />
                      </div>
                      <div style={{position:'absolute',top:0,left:0,right:0,bottom:0,display:'flex',flexDirection:'column',alignItems:'flex-end',justifyContent:'center',paddingRight:10,paddingTop:10}}>
                          <span style={{color:'gray',fontWeight:'bold',fontSize:18,marginBottom:-5,marginTop:5}}>{
                          // @ts-ignore
                          historyDrawResult.length>0? historyDrawResult[0].issueNumber:''}</span>
                          <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:-5}}>
                            <span style={{color:'gray',fontWeight:'bold',fontSize:10,backgroundColor:'#efefef',padding:5,borderRadius:5,marginRight:0}}>{t('Time Remaining')}</span>
                            <CountDown countdown={countdown}/>
                          </div>
                      </div>
                </div>
                
              </div>
            </div>
            <div style={{display:'flex',flex:1,position:'relative',marginTop:-5}}>
              <img src={draw_result_bg} style={{width:'100%'}} />
              <div style={{position:'absolute',left:0,right:0,top:0,bottom:0,display:'flex',alignItems:'center',justifyContent:'center',paddingLeft:20,paddingRight:20}}>
                  <LotteryDrawAnim drawResult={currentDrawResult}/>
              </div>
            </div> 
      </StyledHomeTopBackgroundWrapper>
      <div style={{background:'#F9F9F9', width:'100%',}}>
        <div style={{display:'flex',flexDirection:'row', alignItems:'center', justifyContent:'space-around',boxShadow:'0px 4px 6px rgba(11, 24, 50, 0.12)',fontWeight:'bold',background:'white',borderRadius:10,margin:10,marginBottom:10,marginTop:0,fontSize:18,zIndex:'auto'}}>
                {listTab.map((tab,i)=>{ 
                  const selected = i===selectedList
                  let showSplitter = false
                  if(selectedList==0 && i==1){
                    showSplitter = true
                  }else if(selectedList==2 && i==0){
                    showSplitter = true
                  }
                  return <><span onClick={()=>setSelectedList(i)} style={{position:'relative',color:selected?'white':'gray', background:selected? theme.color.primary.main :'transparent',borderRadius:7,margin:5,fontSize:16,padding:5,paddingBottom:5,flex:1,textAlign:'center'}}>
                    {tab}
                    {/* {i!==selectedList &&<div style={{width:'20%',height:3,borderRadius:10, background:'red',position:'absolute',bottom:0,left:'50%',transform:'translate(-50%,-50%)'}}/>} */}
                    
                  </span>
                  {showSplitter  &&  <div style={{height:20,width:1,background:'gray'}}/>}
                  </>
                })}
        </div>
      {/* <HitTrend hitTrend={hitTrend} hitRate={hitRate} /> */}
      </div>
      {selectedList===1 && selectedTab &&  <LotteryPlan gameType={selectedTab.type+''} gamePath={selectedTab.path}/> }
      {selectedList===2 && <span style={{marginTop:10,width:'100%',flex:1 }}>{!news? <div style={{alignSelf:'stretch',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <Spin/>
         </div>:<div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
          {news.length===0 && 'No News'}
          {news.map((_news)=>{
            return <> 
                <div style={{display:'flex',alignSelf:'stretch',margin:10}} onClick={()=>{
                 window.open('#/article/'+_news.article_id,'_blank') 
                }}> 
                  <img src={_news.img} style={{width:120,height:70,objectFit:'cover'}} alt=''/>
                  <div style={{display:'flex',flexDirection:'column',flex:1,marginLeft:10,justifyContent:'space-between'}}>
                    <span style={{fontWeight:'bold',}}>{_news.title}</span>
                    <span style={{fontSize:14}}>{moment(new Date(_news.time)).fromNow()}</span>
                  </div> 
                </div>
               <div style={{width:'calc( 100% - 20px)',background:'#efefef',height:1}}/>
            </>})}
        </div>}</span>}
      {selectedList===0 && <>
        <LotteryDrawHistory historyDrawResult={historyDrawResult}/>
        
      </>} 
     
     
      {/* {game} {historyDrawResult?.[1]?.lottery.toLowerCase()} */}
      {loadingHistoryStatus&&historyDrawResult.length===0&&<Spin style={{marginTop:10}}/>}
     
      
     
      {/* <LanguageButton/> */}
      {/* <Spacer size='lg'/> 
      <Spacer size='lg'/>  */}
 
        {/* <BottomTab selectedTab={selectedTab}/> */}
        <LotteryPickModal open={openLotteryTypeModal} afterClose={()=>setOpenLotteryTypeModal(false)}/>
    </Page>
  );
};

const LotteryPickModal:React.FC<{afterClose?:()=>void,open:boolean}> = ({afterClose,open})=>{
  const style = useMemo(()=>{
    const ele = document.getElementById('lottery_type_div')
    if(!ele){
      return {}
    }
    return {top:ele.getBoundingClientRect().top+70+10,background:'transparent'}
  },[open])
  const history = useHistory()
  return  <Modal style={style} destroyOnClose open={open}   title={''} footer={null} bodyStyle={{padding:10}} onCancel={()=>{
    afterClose?.()
    
  }} afterClose={()=>{
    afterClose?.()
  
  }}> 
  <Spacer size='lg'/>
  {roundButtons.map(btns=>{
    return <div style={{display:'flex',flexDirection:'row',justifyContent:'space-around'}}>
      {btns.map(btn=>{
          return <div style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',marginBottom:10}} onClick={()=>{
            history.push('/'+btn.lotteryType)
            afterClose?.()
          }}>
              {btn&&<>
                <img src={btn.icon} style={{width:'60%'}}/>
                <div style={{textAlign:'center'}}>{btn.title}</div>
              </>}

            </div>
      })}
    </div>
    
  })} 

   </Modal>
}

export const StyledHomeTopBackgroundWrapper = styled.div`
  background: radial-gradient(32.4% 55.71% at 86.67% 18.5%, rgba(191, 153, 255, 0.8) 0%, rgba(233, 153, 255, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */, linear-gradient(180deg, #0A5EFF 0%, #F9F9F9 100%);
`
const StyledOverview = styled.div`
  align-items: center;
  display: flex;
  @media (max-width: 768px) {
    width: 100%;
    flex-flow: column nowrap;
    align-items: center;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  @media (max-width: 768px) {
    width: 100%;
    flex-flow: column nowrap;
    align-items: center;
  }
`;

const StyledNoticeContainer = styled.div`
  max-width: 768px;
  width: 90vw;
`;

const StyledSpacer = styled.div`
  height: ${(props) => props.theme.spacing[4]}px;
  width: ${(props) => props.theme.spacing[4]}px;
`;

const StyledLink = styled.a`
  font-weight: 700;
  text-decoration: none;
  color: ${(props) => props.theme.color.primary.main};
`;

export default Home;
